var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.49 9.94a2.5 2.5 0 0 0 -2.49-2.44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.2 5.9a4.38 4.38 0 0 1 1.8-.4 4.5 4.5 0 0 1 4.5 4.5 4.34 4.34 0 0 1 -.29 1.55l2.79 2.59a14 14 0 0 0 3-4.14s-3-7-10-7a9.63 9.63 0 0 0 -4 .85zm-6.2-3.9-1 1 2.55 2.4a13.89 13.89 0 0 0 -3.55 4.6s3 7 10 7a9.67 9.67 0 0 0 4.64-1.16l3.36 3.16 1-1zm8 12.5a4.5 4.5 0 0 1 -4.5-4.5 4.45 4.45 0 0 1 .6-2.2l1.53 1.44a2.47 2.47 0 0 0 -.13.76 2.49 2.49 0 0 0 3.41 2.32l1.54 1.45a4.47 4.47 0 0 1 -2.45.73z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eye-closed.e162213a778785c8431067c2c1aee84b.svg";
export { ForwardRef as ReactComponent };